export default [{
  _name: 'CSidebarNav',
  _children: [
    {
      _name: 'CSidebarNavItem',
      name: 'Dashboard',
      to: '/dashboard',
      icon: 'cil-speedometer',
    },

   
    {
      _name: 'CSidebarNavTitle',
      _children: ['Rage Entry ']
    },

    {
      _name: 'CSidebarNavDropdown',
      name: 'Registration',
      route: '/base',
      icon: 'cil-pencil',
      items: [
        {
          name: 'Species ',
          to: '/species'
        },
        {
          name: 'Breed ',
          to: '/breed'
        },
        {
          name: 'Chilling Center',
          to: '/chillingcenter'
        },
        {
          name: 'Union / Zone  ',
          to: '/union'
        },
      
        {
          name: 'Route  ',
          to: '/route'
        },
        {
          name: 'Society  ',
          to: '/society'
        },
        {
          name: 'Owner ',
          to: '/owner'
        },
        // {
        //   name: 'Virutal Lot',
        //   to: '/base/navbars'
        // },
        {
          name: 'Sire ',
          to: '/sire'
        },
        // {
        //   name: 'Purchase / sales party ',
        //   to: '/base/popovers'
        // },
        {
          name: 'Staff ',
          to: '/staff'
        },
        // {
        //   name: 'Union ',
        //   to: '/union'
        // },
        {
          name: 'districts ',
          to: '/districts'
        },
        {
          name: 'animal ',
          to: '/animal'
        },
        {
          name: 'animal1 ',
          to: '/animal1'
        },
        // {
        //   name: 'Insurance Company ',
        //   to: '/base/switches'
        // },
        {
          name: 'Container Master',
          to: '/containermaster'
        },
        // {
        //   name: 'Tabs',
        //   to: '/base/tabs'
        // },
        // {
        //   name: 'Tooltips',
        //   to: '/base/tooltips'
        // }
      ]
    },
   
  ]
}]